<template>
  <div class="switch-option">
    <div class="switch-ellipse" :class="{'active': checked }" @click="clickSwitch">
      <span class="switch-circle" :class="{'active': checked }"></span>
    </div>
  </div>
</template>
<script>
  const COMPONENT_NAME = 'switch-option'
  export default {
    name: COMPONENT_NAME,
    props: {
      name: {
        type: String
      },
      value: null
    },
    data() {
      return {
        checked: this.value
      }
    },
    watch: {
      checked: function (newValue) {
        this.$emit('update:value', newValue)
        this.$emit('input', newValue)
      },
      value(newVal) {
        this.checked = newVal;
      }
    },
    methods: {
      clickSwitch: function () {
        this.checked = !this.checked;
        this.$emit('click');
      }
    }
  }

</script>

<style scoped>
  .switch-option {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    height: 100%;
    align-items: center;
  }

  .name {
    display: flex;
    align-items: center;
    flex: 0 1 auto;
  }

  .switch-ellipse {
    margin: 0;
    display: inline-block;
    position: relative;
    width: 1.064rem;
    height: 0.532rem;
    border: 0.01rem solid #dcdfe6;
    outline: none;
    border-radius: 0.266rem;
    box-sizing: border-box;
    background: #dcdfe6;
    transition: border-color .3s, background-color .3s;
    vertical-align: middle;
    border-color: rgb(255, 73, 73);
    background-color: rgb(255, 73, 73);

  }

  .switch-ellipse.active {
    background-color: #3b99fc;
    border-color: transparent;
    transition: all 0.2s ease 0.2s;
  }

  .switch-circle {
    position: absolute;
    display: inline-block;
    height: 0.425rem;
    width: 0.425rem;
    background: white;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, .1);
    top: 0;
    left: 0;
    transition: all 0.3s;
  }

  .switch-circle.active {
    left: .5rem;
    transition: all 0.4s ease 0.1s;
  }

</style>
